import { HttpHeaders } from '@angular/common/http';
import { AuthSessionService } from '@services/auth-session.service';
import { ToastrService } from 'ngx-toastr';

export class HttpServiceUtil {

  constructor(public toastr: ToastrService) { }

  static setHeadersWithAuth(authSession: AuthSessionService) {
    return authSession.buildHeaders();
  }

  static setHeadersWithAuthAndEvent(authSession: AuthSessionService) {
    return authSession.buildHeaders();
  }

  static setHeaders(authSession?: AuthSessionService) {
    const headers: HttpHeaders = authSession ? authSession.buildHeaders() : new HttpHeaders();

    const options = {
      headers: headers
    }

    return options;
  }

  static errorsHandler(errors: Array<any>, toastr: ToastrService) {
    errors = Object.values(errors);

    for (let i = 0; i < errors.length; i++) {
      toastr.warning(errors[i]);
    }
  }

  static errorHandling(rej, toastr) {
    if (!rej || !toastr) return;

    if (rej?.status === 404) {
      toastr.warning(rej.url.includes('download') ? "Arquivo não encontrado" : "Nenhum resultado encontrado");
    } else if (rej?.status === 0) {
      toastr.error("Não foi possível processar sua solicitação neste momento. O servidor não está respondendo. Por favor, tente novamente mais tarde.", "API inacessível", { progressBar: true, tapToDismiss: false, timeOut: 10000 });
    } else {
      if (rej?.error?.errors) {
        this.errorsHandler(rej.error.errors, toastr);
      } else {
        const title = rej.error?.code ? 'ERRO ' + rej.error.code : '';
        const message = rej.error?.message || 'Não foi possível processar sua solicitação neste momento.';
        toastr.error(message, title, { progressBar: true, tapToDismiss: false, timeOut: 10000 });
      }
    }
  }

}
